<!-- DynamicSelection.vue -->
<template>
  <div v-for="section in modelValue" :key="section.id"
       v-show="section.visible">
    <div class="mb-3"  v-if="(section.group ?? '') === group">
      <label  v-if="shouldUseDropdown(section)" :for="section.id" class="form-label">{{ section.label }}</label>

      <!-- Dropdown for >3 items or allowEmpty -->
      <select
          v-if="shouldUseDropdown(section)"
          :id="section.id"
          class="form-select"
          v-model="section.value"
          @change="emitUpdate(section.id, $event.target.value)">
        <option v-if="section.allowEmpty" value=""></option>
        <option v-if="showRandomOption(section)" value="random">Random</option>
        <option
            v-for="entry in section.activeEntries"
            :key="entry.value"
            :value="entry.value"
        >
          {{ entry.text }}
        </option>
      </select>

      <!-- Radio group for ≤3 items -->
      <div
          v-else
          class="btn-group"
          role="group"
          :aria-label="section.label">
        <template v-if="showRandomOption(section)">
          <input
              type="radio"
              class="btn-check"
              :name="section.id"
              :id="`${section.id}-random`"
              value="random"
              v-model="section.defaultSelection"
              @change="emitUpdate(section.id, $event.target.value)">
          <label
              class="btn btn-outline-secondary"
              :for="`${section.id}-random`">
            Random
          </label>
        </template>
        <template v-for="entry in section.activeEntries" :key="entry.value">
          <input
              type="radio"
              class="btn-check"
              :name="section.id"
              :id="`${section.id}-${entry.value}`"
              :value="entry.value"
              v-model="section.value"
              @change="emitUpdate(section.id, $event.target.value)">
          <label
              class="btn btn-outline-secondary"
              :for="`${section.id}-${entry.value}`">
            {{ entry.text }}
          </label>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicSelection',
  props: {
    modelValue: {
      type: Array,
      required: true,
      validator: function(value) {
        return value.every(item =>
            item.id &&
            item.label &&
            typeof item.allowEmpty === 'boolean' &&
            Array.isArray(item.entries) &&
            item.entries.length > 0
        );
      }
    },
    group: {
      default: ""
    },
    onVisibilityCheck: {
      type: Function,
      required: false
    }
  },
  emits: ['update:modelValue'],
  methods: {
    shouldUseDropdown(section) {
      if(section.renderer === 'radio'){
        return false;
      }

      let count = section.entries.length;
      if (section.randomEnabled && section.randomEnabled !== 'noRandom') {
        count++;
      }
      return count > 3 || section.allowEmpty;
    },
    showRandomOption(section) {
      return section.randomEnabled && section.randomEnabled !== 'noRandom';
    },
    emitUpdate(id, value) {
      const updatedValue = this.modelValue.map(section => {
        if (section.id === id) {
          return { ...section, defaultSelection: value };
        }
        return section;
      });
      this.$emit('update:modelValue', updatedValue);
      this.onVisibilityCheck?.();
    }
  },
  created() {
    // Add visible property to each section if not present
    this.modelValue.forEach(section => {
      if (!Object.prototype.hasOwnProperty.call(section, 'visible')) {
        section.visible = true;
      }
    });
  }
}
</script>